<template>
    <statistics-card-line
        hideChart
        class="mb-base"
        :icon="['fas', 'euro-sign']"
        icon-right
        :statistic="orderValue"
        statisticTitle="Totale waarde"
        color="success"
    />
</template>

<script>
export default {
	props: {
		orderValue: {
			required: true
		},
	},
}
</script>
